import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_CLUSTERS_NAMES,
	GET_ACTIVATION_DATES,
	GET_REPORT_LAST_UPDATE
} from '../actions/ReportsAcceptanceActions';

const initialState = {
	clustersNames: [],
	formState: {
		values: {
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const reportsAcceptanceReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: []
						};
					}
					case GET_CLUSTERS_NAMES: {
						return {
							...state,
							clustersNames: action.clustersNames
						};
					}
					case GET_ACTIVATION_DATES: {
						return {
							...state,
							activationDates: action.activationDates
						};
					}
					case GET_REPORT_LAST_UPDATE: {
						return {
							...state,
							lastUpdate: action.lastUpdate
						};
					}
					default: {
						return state;
					}
	}
};

export default reportsAcceptanceReducer;
